import { getRoutePermission } from '@/config/platform-capabilities';

const Permission = {
  // Catalog
  ReadCatalog: 'ReadCatalog',
  CreateCatalog: 'CreateCatalog',
  UpdateCatalog: 'UpdateCatalog',
  DeleteCatalog: 'DeleteCatalog',
  // Inventory (Transfers)
  ReadInventory: 'ReadInventory',
  CreateInventory: 'CreateInventory',
  UpdateInventory: 'UpdateInventory',
  DeleteInventory: 'DeleteInventory',
  // Purchasing (POs + Vendors)
  ReadPurchaseOrder: 'ReadPurchaseOrder',
  CreatePurchaseOrder: 'CreatePurchaseOrder',
  UpdatePurchaseOrder: 'UpdatePurchaseOrder',
  DeletePurchaseOrder: 'DeletePurchaseOrder',
  // Orders
  ReadOrder: 'ReadOrder',
  CreateOrder: 'CreateOrder',
  UpdateOrder: 'UpdateOrder',
  DeleteOrder: 'DeleteOrder',
  // Customers
  ReadCustomer: 'ReadCustomer',
  CreateCustomer: 'CreateCustomer',
  UpdateCustomer: 'UpdateCustomer',
  DeleteCustomer: 'DeleteCustomer',
  // Promotions
  ReadPromotion: 'ReadPromotion',
  CreatePromotion: 'CreatePromotion',
  UpdatePromotion: 'UpdatePromotion',
  DeletePromotion: 'DeletePromotion',
  // Settings
  ReadSettings: 'ReadSettings',
  UpdateSettings: 'UpdateSettings',
  // Administrators
  ReadAdministrator: 'ReadAdministrator',
  CreateAdministrator: 'CreateAdministrator',
  UpdateAdministrator: 'UpdateAdministrator',
  DeleteAdministrator: 'DeleteAdministrator',
  // Sales Channels
  ReadSalesChannel: 'ReadSalesChannel',
  CreateSalesChannel: 'CreateSalesChannel',
  UpdateSalesChannel: 'UpdateSalesChannel',
  DeleteSalesChannel: 'DeleteSalesChannel',
  // Loyalty
  ReadLoyalty: 'ReadLoyalty',
  ManageLoyalty: 'ManageLoyalty',
  // Shipping
  ReadShipping: 'ReadShipping',
  CreateShipping: 'CreateShipping',
  UpdateShipping: 'UpdateShipping',
  DeleteShipping: 'DeleteShipping',
  // Webhooks & API Keys
  ReadWebhook: 'ReadWebhook',
  ManageWebhook: 'ManageWebhook',
  // Smart Segments
  ReadSmartSegment: 'ReadSmartSegment',
  ManageSmartSegment: 'ManageSmartSegment',
  // Reviews
  ReadReview: 'ReadReview',
  ManageReview: 'ManageReview',
  ReadProductQA: 'ReadProductQA',
  ManageProductQA: 'ManageProductQA',
  ReadTestimonial: 'ReadTestimonial',
  ManageTestimonial: 'ManageTestimonial',
  // Product Labels
  ReadProductLabel: 'ReadProductLabel',
  ManageProductLabel: 'ManageProductLabel',
  // Additional product fields
  ManageMetafieldDefinitions: 'ManageMetafieldDefinitions',
  ManageProductMetafieldValues: 'ManageProductMetafieldValues',
  // Automations
  ReadAutomation: 'ReadAutomation',
  ManageAutomation: 'ManageAutomation',
  // Affiliates
  ReadAffiliate: 'ReadAffiliate',
  ManageAffiliate: 'ManageAffiliate',
  // Scheduling
  ReadScheduling: 'ReadScheduling',
  ManageScheduling: 'ManageScheduling',
  // Product Customizations (replaces retired addon plugin)
  ReadProductCustomization: 'ReadProductCustomization',
  CreateProductCustomization: 'CreateProductCustomization',
  UpdateProductCustomization: 'UpdateProductCustomization',
  DeleteProductCustomization: 'DeleteProductCustomization',
  // Analytics
  ReadAnalytics: 'ReadAnalytics',
  ExportAnalytics: 'ExportAnalytics',
  // Returns
  ReadReturn: 'ReadReturn',
  CreateReturn: 'CreateReturn',
  UpdateReturn: 'UpdateReturn',
  DeleteReturn: 'DeleteReturn',
  ManageReturnSettings: 'ManageReturnSettings',
  // Financial recovery and evidence
  ManagePaymentReconciliation: 'ManagePaymentReconciliation',
  // Invoicing
  ReadInvoice: 'ReadInvoice',
  ManageInvoice: 'ManageInvoice',
  // Gift Cards
  ReadGiftCards: 'ReadGiftCards',
  ManageGiftCards: 'ManageGiftCards',
  // Super
  SuperAdmin: 'SuperAdmin',
} as const;

export type PermissionString = (typeof Permission)[keyof typeof Permission];

export function getRequiredPermissionForRoute(pathname: string): PermissionString | null {
  return getRoutePermission(pathname);
}
